import docCookies from 'doc-cookies';
import { BASE_URL_SANCTUM } from '../misc/consts';

export default () => ({
  form: null,
  sent: false,

  init() {
    this.form = this.$el;
  },

  get action() {
    return this.form.action;
  },

  async getXsfrToken() {
    const response = await fetch(BASE_URL_SANCTUM);
    if (!response.ok) {
      throw new Error(`Error! status: ${response.status}`);
    }
  },

  resetForm() {
    this.form.reset();
  },

  isValid() {
    return this.form.reportValidity();
  },

  async send() {
    if (!this.isValid()) {
      return false;
    }
    await this.getXsfrToken();

    const data = new URLSearchParams(new FormData(this.form));

    fetch(this.action, {
      body: data,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-XSRF-TOKEN': docCookies.getItem('XSRF-TOKEN'),
      },
      method: 'POST',
    })
      .then((response) => {
        if (response.ok) {
          this.resetForm();
          this.sent = true;
        }
      })
      .finally(() => {
        this.sent = false;
        setTimeout(() => {
          this.$dispatch('modal:close');
        }, 3100);
      });
  },
});
